module.exports = __webpack_public_path__ + "img/lead.4fa44949.svg";